import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { usePaymentMethodShortOptions } from "@/hooks/useEnumOptions";

type BillingEntityPaymentElemProps = {
  isDefault: boolean;
  name: string;
  mode: string;
};

export const BillingEntityPaymentElem = ({
  isDefault,
  name,
  mode,
}: BillingEntityPaymentElemProps) => {
  const { t } = useTranslation("boClients");
  const paymentMethodShortOptions = usePaymentMethodShortOptions();
  return (
    <div className="flex max-w-[440px] flex-row items-center justify-between gap-2 rounded-lg border border-gray-300 bg-white p-4 align-middle">
      <div className="gpa-2 flex flex-col gap-1">
        <p className="text-xs font-medium text-gray-600">
          {isDefault
            ? t("profileBillingEntityPaymentElem.defaultBillingEntity")
            : t("profileBillingEntityPaymentElem.additionalBillingEntity")}
        </p>
        <p className="text-base font-medium text-gray-900">{name}</p>
      </div>
      <div className="flex h-fit w-fit flex-row items-center justify-center gap-2 rounded-lg border border-[#BBF7D0] bg-[#F0FDF4] px-2 py-1">
        <Check className="size-4 text-[#15803D]" />
        <p className="h-fit w-fit text-sm font-medium text-[#15803D]">
          {paymentMethodShortOptions.find((el) => el.value === mode)?.label ||
            t("profileBillingEntityPaymentElem.unknownMode")}
        </p>
      </div>
    </div>
  );
};
